import React, { useState } from "react"
import { Card, Row, Col } from "react-bootstrap"
import CreateCaseButton from "../../cases/createCase/CreateCaseButton"
import CreateCaseFormDefault from "../../cases/createCase/CreateCaseFormDefault"
import AccountCasesTable from "./AccountCasesTable"
import Case from "../../../pages/case/index"
import { Button } from "@components/ui/button"

const AccountCasesContainer = ({ account, prospect }) => {
  const [showCaseForm, setShowCaseForm] = useState(false)
  const [reloadMember, setReloadMember] = useState(false)
  const [activeCaseGuid, setActiveCaseGuid] = useState(null)

  const handleBackToTable = () => {
    setActiveCaseGuid(null)
  }

  return (
    <div>
      {!activeCaseGuid ? (
        <Card>
          <Card.Body>
            <Card.Title>
              <Row>
                <Col className="d-flex">
                  <div className="ms-auto">
                    <CreateCaseButton
                      showCaseForm={showCaseForm}
                      setShowCaseForm={setShowCaseForm}
                    />
                  </div>
                </Col>
              </Row>
            </Card.Title>
            <hr />
            <CreateCaseFormDefault
              showCaseForm={showCaseForm}
              setShowCaseForm={setShowCaseForm}
              member={account || prospect}
              setReloadMember={setReloadMember}
            />
            <AccountCasesTable
              prospect={account?.membership_profile.prospect || prospect}
              accountId={account?.account_id}
              reloadCases={reloadMember}
              setActiveCaseGuid={setActiveCaseGuid}
            />
          </Card.Body>
        </Card>
      ) : (
        <>
          <Button onClick={handleBackToTable} variant="link">
            ← Back to cases table
          </Button>
          <Case caseGuid={activeCaseGuid} />
        </>
      )}
    </div>
  )
}

export default AccountCasesContainer
